// =====================================================
// 📁 POSExportRegimeSection.tsx
// =====================================================

import { useEffect } from 'react';

import { useSale } from '../../../../../hooks/sale/useSale';

import { useExportRegime } from '../../../../../hooks/exportRegimes/useExportRegime';

import { useExportInvoiceSale } from '../../../../../hooks/sale/useExportInvoiceSale';

import POSSelectField from '../../../../POS/Fields/POSSelectField';

const POSExportRegimeSection = () => {
  // =====================================================
  // 🔹 Hooks
  // =====================================================
  const { form } = useSale();

  const { handlerUpdateExportRegime } = useExportInvoiceSale();

  const {
    exportRegimeDropdown,

    fetchExportRegimeDropdown,
  } = useExportRegime();

  // =====================================================
  // 🔹 Effects
  // =====================================================
  useEffect(() => {
    fetchExportRegimeDropdown('');
  }, []);

  // =====================================================
  // 🔹 Options
  // =====================================================
  const options = exportRegimeDropdown.map((item) => ({
    value: item.id,

    label: item.name,
  }));

  // =====================================================
  // 🔹 Selected
  // =====================================================
  const selectedValue = form.exportInvoiceExtra?.exportRegime?.id ?? '';

  // =====================================================
  // 🎨 Render
  // =====================================================
  return (
    <div className="space-y-2">
      {/* ===================================================== */}
      {/* 🔹 Title */}
      {/* ===================================================== */}
      <div>
        <h4
          className="
            text-sm
            font-semibold
            text-black

            dark:text-white
          "
        >
          Régimen de Exportación
        </h4>

        <p
          className="
            mt-1

            text-xs
            text-body
          "
        >
          Selecciona el régimen correspondiente para la exportación.
        </p>
      </div>

      {/* ===================================================== */}
      {/* 🔹 Select */}
      {/* ===================================================== */}
      <POSSelectField
        label="Régimen"
        name="exportRegime"
        placeholder="Seleccione régimen"
        value={selectedValue}
        options={options}
        iconKey="list"
        onChange={async (e) => {
          const selectedId = Number(e.target.value);

          if (!form?.id) {
            return;
          }

          await handlerUpdateExportRegime(form.id, selectedId);
        }}
      />
    </div>
  );
};

export default POSExportRegimeSection;
